import { lazy, ReactElement, useMemo } from 'react';

import { LoadingScreen } from '@/components';
import { useAuth } from '@/hooks';
import { APP_ROUTES } from '@/routes';
import { PaywallDataResponse } from '@/types/components';

const RedirectPage = lazy(() => import('@/pages/RedirectPage'));

export const withPaywall = (WrappedComponent: ReactElement) => {
  return (route: string, paywallData?: PaywallDataResponse) => {
    const auth = useAuth();

    if (!auth.isAuthenticated) {
      return <LoadingScreen />;
    }

    const pageUrls: string[] = [APP_ROUTES.cdfiReport, APP_ROUTES.cdfiCertification];

    const resultArr = useMemo(() => {
      if (!paywallData) {
        return [];
      }

      return paywallData.Pages.filter((page) => {
        const [_, pageUrl] = page.split('#');
        return pageUrls.includes(pageUrl);
      }).map((page) => page.replace(/[^#]+/, ''));
    }, [paywallData, pageUrls]);

    if (!resultArr.includes(`#${route}`) && paywallData) {
      return <RedirectPage redirectLink={paywallData.RedirectUrl} />;
    }

    return WrappedComponent;
  };
};
